// Module
var code = "<div class=\"block height-100\"> <h2>All Contacts: Identify group ones</h2> <div id=\"viewGrid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;